export default "__VITE_ASSET__DTtL_EOy__"